var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w2-loading-mask"},[_c('div',{staticClass:"w2-loading-animate"})])
}]

export { render, staticRenderFns }